import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import locale from 'element-ui/lib/locale/lang/ua'
import router from './router'

import 'element-ui/lib/theme-chalk/display.css';

import {httpClient} from "@/api/httpClient";

const token = localStorage.getItem('user-token')
if (token) {
  httpClient.defaults.headers.common['Authorization'] = "Token " + token
}

Vue.use(ElementUI, { locale })

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
